import React from 'react';
import { Zap, Minus, CornerDownRight, Waves, MoreHorizontal } from 'lucide-react';

const STYLE_OPTIONS = [
  { value: 'straight', label: 'Düz', Icon: Minus, desc: 'Klassik birbaşa xətt' },
  { value: 'curved', label: 'Əyri', Icon: CornerDownRight, desc: 'Yumşaq Bezier əyrisi' },
  { value: 'wavy', label: 'Dalğalı', Icon: Waves, desc: 'Sinusoidal dalğa' },
  { value: 'dashed', label: 'Kəsik', Icon: MoreHorizontal, desc: 'Kəsik-kəsik axan xətt' },
];

const AnimationEditor = ({ connectionSpeed = 1, connectionStyle = 'straight', onChange }) => {
  return (
    <div className="admin-section" data-testid="animation-editor-section">
      <h3 className="admin-section-title flex items-center gap-2">
        <Zap size={18} className="text-yellow-400" /> Bağlantı animasiyası
      </h3>
      <p className="admin-section-desc">
        Xətlərin gediş-gəliş sürətini və formasını dəyişin.
      </p>

      {/* Speed slider */}
      <div className="anim-speed-wrap">
        <div className="flex items-center justify-between mb-2">
          <label className="text-sm font-semibold text-white/90">Sürət</label>
          <span className="text-sm font-mono text-yellow-300" data-testid="conn-speed-value">
            {connectionSpeed.toFixed(2)}x
          </span>
        </div>
        <input
          type="range"
          min="0.3" max="3" step="0.05"
          value={connectionSpeed}
          onChange={(e) => onChange({ connection_speed: parseFloat(e.target.value) })}
          className="size-slider"
          data-testid="conn-speed-slider"
        />
        <div className="flex justify-between text-xs text-white/40 mt-1">
          <span>Yavaş (0.3x)</span>
          <span>Normal (1x)</span>
          <span>Sürətli (3x)</span>
        </div>
      </div>

      {/* Style selector */}
      <div className="anim-style-title">Xətt forması</div>
      <div className="anim-style-grid">
        {STYLE_OPTIONS.map(({ value, label, Icon, desc }) => {
          const isActive = connectionStyle === value;
          return (
            <button
              key={value}
              onClick={() => onChange({ connection_style: value })}
              className={`anim-style-btn ${isActive ? 'anim-style-btn-active' : ''}`}
              data-testid={`conn-style-${value}`}
            >
              <Icon size={22} />
              <span className="anim-style-label">{label}</span>
              <span className="anim-style-desc">{desc}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AnimationEditor;
